import { getApiUrl } from '../../../config/api';
import { post } from '../../../utils/request-manager';

export default class ModulosViewController {
  constructor() {
    this.modulos = [];
    this.loading = false;
    this.error = null;
    this.sortField = null;
    this.sortDirection = 'asc';
    this.currentPage = 1;
    this.itemsPerPage = 10;
  }

  // Inicializar el controlador
  async initialize() {
    await this.loadModulos();
  }

  // Cargar módulos desde la API
  async loadModulos() {
    this.loading = true;
    this.error = null;

    console.log("buscando modulos ... ");
    
    try {
      const response = await post(getApiUrl('/api/Modulo/listar'), {});
      this.modulos = response.data || [];
      this.loading = false;
    } catch (error) {
      console.error('Error al cargar módulos:', error);
      this.error = 'No se pudieron cargar los módulos. Por favor, intente nuevamente.';
      this.loading = false;
    }
  }

  // Recargar módulos
  async reloadModulos() {
    await this.loadModulos();
  }

  // Eliminar módulo
  async deleteModulo(idModulo) {
    try {
      const deleteData = { Modulo: { IdModulo: idModulo } };
      const response = await post(getApiUrl('/api/Modulo/borrar'), deleteData, {}, false);
      return response;
    } catch (error) {
      console.error('Error al eliminar módulo:', error);
      throw error;
    }
  }

  // Ordenar datos
  sort(field) {
    if (this.sortField === field) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortField = field;
      this.sortDirection = 'asc';
    }
  }

  // Obtener datos ordenados
  get sortedData() {
    if (!this.sortField) return this.modulos;
    
    return [...this.modulos].sort((a, b) => {
      let aVal = a[this.sortField];
      let bVal = b[this.sortField];
      
      // Manejar fechas
      if (this.sortField === 'FechaCreacion') {
        aVal = new Date(aVal);
        bVal = new Date(bVal);
      }
      
      // Manejar números
      if (typeof aVal === 'number' && typeof bVal === 'number') {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      // Manejar strings
      if (typeof aVal === 'string' && typeof bVal === 'string') {
        return this.sortDirection === 'asc' 
          ? aVal.localeCompare(bVal)
          : bVal.localeCompare(aVal);
      }
      
      // Manejar fechas
      if (aVal instanceof Date && bVal instanceof Date) {
        return this.sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
      }
      
      return 0;
    });
  }

  // Obtener datos paginados
  get paginatedData() {
    const sorted = this.sortedData;
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    return sorted.slice(start, end);
  }

  // Obtener total de páginas
  get totalPages() {
    return Math.ceil(this.modulos.length / this.itemsPerPage);
  }

  // Obtener icono de ordenamiento
  sortIcon(field) {
    if (this.sortField !== field) return 'bi bi-arrow-down-up';
    return this.sortDirection === 'asc' ? 'bi bi-arrow-up' : 'bi bi-arrow-down';
  }

  // Cambiar página
  changePage(page) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
    }
  }
}